import { SsqSsqHeading, SsqSsqHeadingSsqProperty } from "src/api/sure-api/ssq/useGetOneSsqVersion";

export type UnifiedSubheadingItem = {
    type: "subheading";
    data: SsqSsqHeading;
    position: number;
};

export type UnifiedPropertyItem = {
    type: "property";
    data: SsqSsqHeadingSsqProperty;
    position: number;
};

export type UnifiedItem = UnifiedSubheadingItem | UnifiedPropertyItem;

export const unifyHeadingsAndProperties = (
    subheadings: SsqSsqHeading[],
    properties: SsqSsqHeadingSsqProperty[],
): UnifiedItem[] => {
    const unifiedSubheadings: UnifiedItem[] = subheadings.map((subheading) => ({
        type: "subheading" as const,
        data: subheading,
        position: subheading.position ?? 0,
    }));

    const unifiedProperties: UnifiedItem[] = properties.map((property) => ({
        type: "property" as const,
        data: property,
        position: property.position ?? 0,
    }));

    return [...unifiedSubheadings, ...unifiedProperties].sort((a, b) => a.position - b.position);
};
